export default __webpack_public_path__ + "media/images/51-e802ca9e54e387ab117f846fc4bda7b8.png";